<div class="inline-error" role="alert" aria-live="polite">
  <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
  <div class="inline-error__body">
    <span class="inline-error__message">{{ message() }}</span>
    @if (detail()) {
      <span class="inline-error__detail">{{ detail() }}</span>
    }
  </div>
  @if (retryable()) {
    <button
      type="button"
      class="inline-error__retry"
      (click)="retry.emit()"
    >
      <i class="pi pi-refresh" aria-hidden="true"></i> Retry
    </button>
  }
</div>
